(function () {
  'use strict';

  var STORAGE_KEY = 'primmeshiper_vat_display_v1';
  var PRICE_SELECTOR = [
    'span.money-subtotal',
    'span.price-item.price-item--sale',
    's.price.price--end',
    'dd.price.price--end',
    'span.price.price--end',
    'span.cart-item-value',
    'span.vat-price',
    'span.discounted-price',
    'dd.price__last > span.price-item.price-item--regular',
    '.hidePrice',
    's.price-item.price-item--regular',
    's.before-discount-price',
    '[data-product-tags].price-item',
    '[data-product-tags][data-item-final-price-display]',
    '[data-product-tags][data-item-original-price-display]'
  ].join(',');
  var AGGREGATE_SELECTOR = '[data-ps-vat-incl-cents][data-ps-vat-excl-cents]';
  var cache = new WeakMap();
  var mode = readMode();
  var scheduled = false;

  document.documentElement.setAttribute('data-ps-vat-mode', mode);

  function readMode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'ex' ? 'ex' : 'inc';
    } catch (error) {
      return 'inc';
    }
  }

  function saveMode(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      /* Display still works when storage is unavailable. */
    }
  }

  function tagsFor(element) {
    var tagged = element.hasAttribute('data-product-tags')
      ? element
      : element.closest('[data-product-tags]');
    if (!tagged) {
      var priceContainer = element.closest('.price, .card, .product, .previewCartItem, .cart-item');
      tagged = priceContainer && priceContainer.querySelector('[data-product-tags]');
    }
    return tagged ? (tagged.getAttribute('data-product-tags') || '').toLowerCase() : '';
  }

  function vatRate(element) {
    var tags = tagsFor(element);
    if (tags.indexOf('0% vat') !== -1 || tags.indexOf('vat 0 %') !== -1) return 0;
    if (tags.indexOf('6% vat') !== -1 || tags.indexOf('vat 6 %') !== -1) return 6;
    if (tags.indexOf('12% vat') !== -1 || tags.indexOf('vat 12 %') !== -1) return 12;
    return 25;
  }

  function parseNumber(raw) {
    var value = raw.replace(/[\s\u00a0']/g, '');
    var comma = value.lastIndexOf(',');
    var dot = value.lastIndexOf('.');
    var separator = Math.max(comma, dot);
    if (separator !== -1 && value.length - separator - 1 <= 2) {
      value = value.slice(0, separator).replace(/[.,]/g, '') + '.' + value.slice(separator + 1);
    } else {
      value = value.replace(/[.,]/g, '');
    }
    return Number(value);
  }

  function decimalsIn(raw) {
    var match = raw.match(/[.,](\d{1,2})$/);
    return match ? match[1].length : 0;
  }

  function formatNumber(value, sample) {
    var decimals = decimalsIn(sample);
    var comma = sample.lastIndexOf(',');
    var dot = sample.lastIndexOf('.');
    var locale = dot > comma && sample.length - dot - 1 <= 2 ? 'en-US' : 'sv-SE';
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  }

  function transformMoneyText(text, rate) {
    if (mode === 'inc' || rate === 0) return text;
    return text.replace(/\d[\d\s\u00a0'.,]*\d|\d/g, function (token) {
      var number = parseNumber(token);
      if (!Number.isFinite(number)) return token;
      var converted = Math.round((number / (1 + rate / 100)) * 100) / 100;
      return formatNumber(converted, token);
    });
  }

  function renderPrice(element) {
    if (!element || element.closest('[data-ps-vat-switcher]') || element.matches(AGGREGATE_SELECTOR)) return;
    var current = element.textContent;
    var record = cache.get(element);
    if (!record || (current !== record.last && current !== record.source)) {
      record = { source: current, last: current };
      cache.set(element, record);
    }
    var output = transformMoneyText(record.source, vatRate(element));
    if (current !== output) element.textContent = output;
    record.last = output;
  }

  function renderAggregate(element) {
    var cents = Number(element.getAttribute(mode === 'ex' ? 'data-ps-vat-excl-cents' : 'data-ps-vat-incl-cents'));
    if (!Number.isFinite(cents)) return;
    var current = element.textContent;
    var record = cache.get(element);
    if (!record || (current !== record.last && current !== record.source)) {
      record = { source: current, last: current };
      cache.set(element, record);
    }
    var output = record.source.replace(/\d[\d\s\u00a0'.,]*\d|\d/, function (token) {
      return formatNumber(cents / 100, token);
    });
    if (current !== output) element.textContent = output;
    record.last = output;
  }

  function syncSwitchers() {
    document.querySelectorAll('[data-ps-vat-switcher]').forEach(function (switcher) {
      switcher.setAttribute('data-mode', mode);
      var toggle = switcher.querySelector('[data-ps-vat-toggle]');
      if (toggle && !toggle.hasAttribute('data-ps-vat-bound')) {
        toggle.setAttribute('data-ps-vat-bound', 'true');
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setMode(mode === 'inc' ? 'ex' : 'inc');
        });
      }
      switcher.querySelectorAll('[data-ps-vat-mode]').forEach(function (choice) {
        var active = choice.getAttribute('data-ps-vat-mode') === mode;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    });
  }

  function renderAll() {
    scheduled = false;
    if (!document.querySelector('[data-ps-vat-switcher]')) return;
    document.querySelectorAll(PRICE_SELECTOR).forEach(renderPrice);
    document.querySelectorAll(AGGREGATE_SELECTOR).forEach(renderAggregate);
    syncSwitchers();
    document.documentElement.setAttribute('data-ps-vat-mode', mode);
  }

  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(renderAll);
  }

  function mutationNeedsRender(mutations) {
    return mutations.some(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && (target.matches(PRICE_SELECTOR + ',' + AGGREGATE_SELECTOR) || target.closest(PRICE_SELECTOR + ',' + AGGREGATE_SELECTOR))) {
        return true;
      }
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches(PRICE_SELECTOR + ',' + AGGREGATE_SELECTOR + ',[data-ps-vat-switcher]') ||
          node.querySelector(PRICE_SELECTOR + ',' + AGGREGATE_SELECTOR + ',[data-ps-vat-switcher]');
      });
    });
  }

  function setMode(value) {
    mode = value === 'ex' ? 'ex' : 'inc';
    saveMode(mode);
    renderAll();
    document.dispatchEvent(new CustomEvent('primmeshiper:vat-change', { detail: { mode: mode } }));
  }

  document.addEventListener('click', function (event) {
    var choice = event.target.closest('.ps-vat-choice[data-ps-vat-mode]');
    if (choice) {
      event.preventDefault();
      setMode(choice.getAttribute('data-ps-vat-mode'));
      return;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var choice = event.target.closest('.ps-vat-choice[data-ps-vat-mode]');
    if (!choice || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
    event.preventDefault();
    var nextMode = event.key === 'ArrowLeft' || event.key === 'Home' ? 'ex' : 'inc';
    setMode(nextMode);
    var switcher = choice.closest('[data-ps-vat-switcher]');
    var nextChoice = switcher && switcher.querySelector('.ps-vat-choice[data-ps-vat-mode="' + nextMode + '"]');
    if (nextChoice) nextChoice.focus();
  });

  document.addEventListener('DOMContentLoaded', function () {
    renderAll();
    new MutationObserver(function (mutations) {
      if (mutationNeedsRender(mutations)) scheduleRender();
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });

  window.primmeshiperVatRefresh = scheduleRender;
  window.vatSwitcherInit = scheduleRender;
})();
